<get-started-animation
  *ngIf="this.sharedConfig.showLottieFullScreen"
  [animationSrc]="animationSrc"
  [sub_heading]="sub_heading"
></get-started-animation>

<form [formGroup]="registerForm" novalidate>
  <!-- <div class="h-100" *ngIf="screenIndex === 1">
    <div class="slider-wrapper limit-width-on-desktop">
      <div class="wrapper">
        <div class="heading-section">
          <h2 class="h2-bold">Let's get to know you better</h2>
        </div>
        <div class="input-section">
          <ion-checkbox slot="end" formControlName="popia_consent" style="display: none;"></ion-checkbox>
          <ion-input formControlName="popia_message" [ngModelOptions]="{ standalone: true }" type="text" style="display: none;"></ion-input>
          <ion-item mode="ios">
            <ion-input
              labelPlacement="floating"
              (keydown)="nextOnEnter($event)"
              class="capitalize"
              autocapitalize="words"
              formControlName="name"
              type="text"
              [ngModelOptions]="{ standalone: true }"
            >
            <div slot="label">
              <ion-text class="standard-input-label">First name</ion-text>
            </div>
          </ion-input>
          </ion-item>
          <p *ngIf="registerForm.get('name').errors?.containsNumbers" class="error-message">
            First name cannot contain numbers
          </p>
          <p *ngIf="!registerForm.controls.name.valid && registerForm.controls.name.dirty && !registerForm.get('name').errors?.containsNumbers" class="error-message">
            Enter a valid name
          </p>
          
          <ion-item mode="ios">
            <ion-input
              labelPlacement="floating"
              (keydown)="nextOnEnter($event)"
              class="capitalize"
              autocapitalize="words"
              formControlName="surname"
              type="text"
              [ngModelOptions]="{ standalone: true }"
            >
            <div slot="label">
              <ion-text class="standard-input-label">Surname</ion-text>
            </div>
          </ion-input>
          </ion-item>
          <p *ngIf="registerForm.get('surname').errors?.containsNumbers" class="error-message">
            Surname cannot contain numbers
          </p>
          <p *ngIf="!registerForm.controls.surname.valid && registerForm.controls.surname.dirty && !registerForm.get('surname').errors?.containsNumbers" class="error-message">
            Enter a valid surname
          </p>
        </div>
        <div class="button-section limit-width-on-desktop">
          <ion-button
            mode="ios"
            type="button"
            class="primary-button"
            (click)="registerFormSlideNext()"
            [disabled]="!registerForm.controls.name.valid || !registerForm.controls.surname.valid"
          >
            Next
          </ion-button>
          <div class="terms-wrapper">
            <p>
              By registering you agree to our <br /><a href="{{ sharedConfig.appSettings?.terms_url }}" target="_blank"
                >Terms and Conditions and Privacy Policy</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-banner">
      <ion-grid class="footer-grid limit-width-on-desktop">
        <ion-row>
          <ion-col size="9">Already have an account?</ion-col>
          <ion-col size="3" class="text-right"><a (click)="loginPage()">Log in</a></ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div> -->
  <div *ngIf="screenIndex === 1">
    <div class="slider-wrapper">
      <div class="wrapper limit-width-on-desktop">
        <div class="heading-section">
          <h2 class="h2-bold">Let’s set up your account</h2>
          <p class="mail-text">We’ll need your email and a password. You'll use these to log in.</p>
        </div>
        <div class="input-section">
          <ion-item mode="ios">
            <ion-input labelPlacement="floating" (keydown)="registerOnEnter($event)" formControlName="email" [ngModelOptions]="{ standalone: true }" type="email">
              <div slot="label">
                <ion-text class="standard-input-label">Email address</ion-text>
              </div>
            </ion-input>
          </ion-item>
          <p *ngIf="!registerForm.controls.email.valid && registerForm.controls.email.dirty" class="error-message">Please provide a valid email</p>
          <ion-item mode="ios">
            <ion-input
              labelPlacement="floating"
              (keydown)="registerOnEnter($event)"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="password"
              formControlName="password1"
              type="{{ passwordType }}"
              (ionInput)="checkPassword($event)"
            >
            <div slot="label">
              <ion-text class="standard-input-label">Password</ion-text>
            </div>
          </ion-input>
            <ion-icon slot="end" src="assets/icon/input-icons/{{ passwordIcon }}.svg" class="passwordIcon" (click)="showPassword()"></ion-icon>
          </ion-item>
          <div style="margin-top:10px;">
            <small>
              <!-- Password must contain <b [ngClass]="{'success-text': pwdhas8orMoreChar, 'unsuccessful-text': !pwdhas8orMoreChar}">at least 8 characters</b>, <b [ngClass]="{'success-text': pwdHasLowercase, 'unsuccessful-text': !pwdHasLowercase}">a lower case character</b>, 
              <b [ngClass]="{'success-text': pwdHasUppercase, 'unsuccessful-text': !pwdHasUppercase}">an upper case character</b>, <b [ngClass]="{'success-text': pwdHasSpecialChar, 'unsuccessful-text': !pwdHasSpecialChar}">a special character</b>,
              <b [ngClass]="{'success-text': pwdHasNumericChar, 'unsuccessful-text': !pwdHasNumericChar}">a numeric character</b>. -->
              <li [ngClass]="{'success-text': pwdhas8orMoreChar, 'unsuccessful-text': !pwdhas8orMoreChar}">Password must contain at least 8 characters.</li>
              <li [ngClass]="{'success-text': pwdHasLowercase, 'unsuccessful-text': !pwdHasLowercase}">Password must contain a lower case character.</li>
              <li [ngClass]="{'success-text': pwdHasUppercase, 'unsuccessful-text': !pwdHasUppercase}">Password must contain an upper case character.</li>
              <li [ngClass]="{'success-text': pwdHasSpecialChar, 'unsuccessful-text': !pwdHasSpecialChar}">Password must contain a special character.</li>
              <li [ngClass]="{'success-text': pwdHasNumericChar, 'unsuccessful-text': !pwdHasNumericChar}">Password must contain a numeric character.</li>
            </small>
          </div>
          <!-- <p class="error-message" *ngIf="!registerForm.controls.password1.valid && registerForm.controls.password1.dirty">Invalid password</p> -->
          <div class="consent">
            <ion-item lines="none">
              <ion-checkbox slot="start" formControlName="client_consent"></ion-checkbox>
              <ion-label class="ion-text-wrap">
                I give Momentum Insure permission to share and process my personal information as set out in the <a href="https://www.momentum.co.za/momentum/compliance/privacy-policy" target="_blank">privacy policy</a>.
                <div style="display: inline; padding: 0 5px;" (click)="openInfo()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" class="icon-fill-primary" viewBox="0 0 16 16">
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                  </svg>
                </div>
              </ion-label>
            </ion-item>
          </div>
        </div>
        <div class="button-section">
          <div *ngIf="sharedConfig?.appSettings?.list_brokers_on_registration && !brokerAutoAssigned" class="button-section">
            <ion-button
              mode="ios"
              type="button"
              class="primary-button"
              [disabled]="!registerForm.controls.email.valid || !passwordRequirementsPassed || !registerForm.value.client_consent"
              (click)="registerFormSlideNext()"
            >
              Next
            </ion-button>
          </div>
          <div *ngIf="!sharedConfig?.appSettings?.list_brokers_on_registration || brokerAutoAssigned" class="button-section">
            <ion-button
              mode="ios"
              (click)="initializeRegistration()"
              [disabled]="!registerForm.controls.email.valid || !passwordRequirementsPassed || !registerForm.value.client_consent"
              class="primary-button"
            >
              Register
            </ion-button>
          </div>
          <div class="disclaimer">
            <p style="font-size: 12px;">Momentum Insure is a licenced non life insurer and authorised financial services provider. If we fail to deliver on our promises, your valued feedback can be provided <a href="https://wwpre.momentum.co.za/momentum/personal/car-and-home-insurance/legal-and-compliance" target="_blank" style="color: black; font-weight: 600;">here</a>.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="screenIndex === 2 && sharedConfig?.appSettings?.list_brokers_on_registration && !brokerAutoAssigned">
    <div class="slider-wrapper">
      <div class="broker-progress"></div>
      <div class="wrapper limit-width-on-desktop">
        <div class="heading-section remove-bottom-padding">
          <h2 class="h2-bold" *ngIf="sharedConfig.appSettings?.search_broker_with_code;else other_header_wording">Add your adviser</h2>
          <ng-template #other_header_wording>
            <h2 class="h2-bold">Add your branch</h2>
          </ng-template>
          <p class="p-meduim" *ngIf="sharedConfig.appSettings?.search_broker_with_code;else other_sub_wording">Please enter your unique 5-digit code that was provided by your adviser.</p>
          <ng-template #other_sub_wording><p class="p-meduim">Please select a branch below.</p></ng-template>
        </div>
        <div class="input-section" *ngIf="sharedConfig.appSettings?.search_broker_with_code">
          <ion-item mode="ios">
            <ion-input
              labelPlacement="floating"
              #brokerCodeInput
              *ngIf="brokers"
              maxlength="5"
              value="{{ brokerCodeValue ? brokerCodeValue : sharedConfig.appSettings.broker_search_prefix }}"
              debounce="2000"
              (ionInput)="searchBrokers($event)"
              [ngModelOptions]="{ standalone: true }"
            >
            <div slot="label">
              <ion-text class="standard-input-label">Your 5-digit code starting with {{ sharedConfig.appSettings.broker_search_prefix }}</ion-text>
            </div>
            </ion-input>
          </ion-item>
          <div class="search-results-wrapper" *ngIf="showBrokerResults === true">
            <div class="inner-wrapper" *ngFor="let broker of brokers">
              <p (click)="showBrokerDetails(broker)">{{ broker.contact }}</p>
            </div>
          </div>
        </div>
        <div class="info-card"  *ngIf="sharedConfig.appSettings?.search_broker_with_code">
          <p>
            Don't have a code? Please contact your financial adviser to get their unique franchise code - this will ensure that you are allocated to
            the correct adviser. Alternatively, please select a financial adviser below.
          </p>
        </div>
        <div class="input-section">
          <ion-item mode="ios">
            <ion-input
              labelPlacement="floating"
              [ngModelOptions]="{ standalone: true }"
              readonly="true"
              [(ngModel)]="selectedAdvisor"
              (click)="openSelectAdvisor()"
            >
            <div *ngIf="sharedConfig.appSettings?.search_broker_with_code;else other_label" slot="label">
              <ion-text class="standard-input-label">Choose an advisor</ion-text>
            </div>
            <ng-template #other_label>
              <div slot="label">
                <ion-text class="standard-input-label">Choose a branch</ion-text>
              </div>
            </ng-template>
          </ion-input>
          </ion-item>
        </div>

        <div class="button-section">
          <ion-button [disabled]="!enableBrokerNextButton" mode="ios" (click)="assignBrokerAndGoNext()" class="primary-button"> Next </ion-button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="screenIndex === 3 && sharedConfig?.appSettings?.list_brokers_on_registration && !brokerAutoAssigned">
    <div class="slider-wrapper">
      <div class="wrapper limit-width-on-desktop">
        <div class="success-card">
          <ul class="custom">
            <li style="background: url(assets/icon/genetic-icons/checkbox-tick-success-consult.svg) no-repeat">
              <h2 class="h2-bold">Success</h2>
            </li>
            <li>
              <b>{{ brokerName }} ({{ brokerSearchCode }})</b> from <b>{{ brokerAgent }}</b> was added as your adviser.
            </li>
          </ul>
        </div>
        <div class="start-over">
          <small>Not the correct adviser? <a (click)="prevQuestion()">Start over</a></small>
        </div>

        <div class="button-section">
          <ion-button [disabled]="!enableRegisterButton" mode="ios" (click)="initializeRegistration()" class="primary-button"> Register </ion-button>
        </div>
      </div>
    </div>
  </div>
  <div class="mini-version">
    <p>{{sharedConfig.appVersion}}</p>
  </div>

</form>

<div class="backdrop" *ngIf="showSelectBroker"></div>
<div class="popup-dates limit-width-on-desktop-float" *ngIf="showSelectBroker">
  <div class="text-center">
    <h2 class="h2-bold">Choose an advisor</h2>
  </div>
  <div class="dates">
    <div class="date-wrapper clickable" *ngFor="let brokers of allBrokers" (click)="selectAdvisor(brokers)">
      {{ brokers.adviser_name_town }}
    </div>
  </div>
  <ion-button class="secondary-button" (click)="dismissChooseBrokerPopup()">Close</ion-button>
</div>

<popup-dialog id="signup.component" *ngIf="sharedConfig.popupDialogShow"></popup-dialog>